(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    // Move buy buttons after specs on product page
  document.addEventListener('DOMContentLoaded', function() {
    const productInfo = document.querySelector('.product-information');
    if (productInfo) {
      const buyButtons = productInfo.querySelector('.buy-buttons-block');
      const specsContainer = productInfo.querySelector('.product-detail-inner--specs');

      if (buyButtons && specsContainer) {
        // Move buy buttons after specs
        specsContainer.after(buyButtons);
      }

      // Add expandable functionality to product description
      const toggleBtn = productInfo.querySelector('.description-toggle-btn');
      const textBlocks = productInfo.querySelectorAll('.product-detail-item--blocks .text-block.rte');
      let descriptionBlock = null;

      // Find the description block that needs truncation
      textBlocks.forEach(function(block) {
        if (block.classList.contains('description-processed')) return;
        block.classList.add('description-processed');

        // Temporarily remove max-height to measure true height
        const originalMaxHeight = block.style.maxHeight;
        block.style.maxHeight = 'none';
        const fullHeight = block.scrollHeight;
        block.style.maxHeight = originalMaxHeight;

        // Check if this block has enough content to need truncation (> 70px)
        if (fullHeight > 70) {
          descriptionBlock = block;
        } else {
          // Short content - remove truncation
          block.classList.add('description-no-truncate');
        }
      });

      // If we found a description that needs truncation, set up the toggle
      if (descriptionBlock && toggleBtn) {
        // Move button right after the description block
        descriptionBlock.parentNode.insertBefore(toggleBtn, descriptionBlock.nextSibling);
        toggleBtn.style.display = '';

        // Toggle functionality
        toggleBtn.addEventListener('click', function() {
          const isExpanded = descriptionBlock.classList.contains('description-expanded');
          if (isExpanded) {
            descriptionBlock.classList.remove('description-expanded');
            toggleBtn.classList.remove('expanded');
            toggleBtn.querySelector('.toggle-text').textContent = '... Read more';
          } else {
            descriptionBlock.classList.add('description-expanded');
            toggleBtn.classList.add('expanded');
            toggleBtn.querySelector('.toggle-text').textContent = 'Show less';
          }
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // Buy Now button functionality
  document.addEventListener('DOMContentLoaded', function() {
    const buyNowButtons = document.querySelectorAll('[data-buy-now]');

    buyNowButtons.forEach(function(button) {
      button.addEventListener('click', async function(e) {
        e.preventDefault();

        // Find the parent form to get the variant ID
        const form = button.closest('form');
        if (!form) return;

        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput) return;

        const variantId = variantInput.value;
        const textSpan = button.querySelector('.buy-now-text');
        const loadingSpan = button.querySelector('.buy-now-loading');

        // Show loading state
        button.disabled = true;
        if (textSpan) textSpan.style.display = 'none';
        if (loadingSpan) loadingSpan.style.display = 'inline';

        try {
          // Add to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

          if (response.ok) {
            // Redirect to checkout
            window.location.href = '/checkout';
          } else {
            const error = await response.json();
            alert(error.description || 'Could not add to cart. Please try again.');
            // Reset button state
            button.disabled = false;
            if (textSpan) textSpan.style.display = 'inline';
            if (loadingSpan) loadingSpan.style.display = 'none';
          }
        } catch (err) {
          alert('Something went wrong. Please try again.');
          // Reset button state
          button.disabled = false;
          if (textSpan) textSpan.style.display = 'inline';
          if (loadingSpan) loadingSpan.style.display = 'none';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
